import { gql } from '@apollo/client'

const QueryData = gql`
  query lockers {
    kiosk {
      lockers(
          orderBy: {field: "name", order: ASC}
      ) {
        nodes {
          ... on LockControlPort {
            __typename
            id
            name
          }
          ... on TwoWireLock {
            __typename
            id
            name
          }
        }
      }
    }
  }

`
export default QueryData
